import type { SgApplicationConfiguration } from './types';

const ONBOARDING_APP_DETECT_REGEXP = new RegExp(`^(?:#/|#|/)(sg-onboarding)(?:/|\\?|().*)?$`);
const HOSTNAME_DETECT_REGEXP = new RegExp(`^onboarding(?:-.*)?\\.sharegain\\.com$`);

declare module '@sg/pre-app-init/src/lib/application' {
  export interface SgCustomAppBranding {
    'sg-onboarding': {
      logoMainPage: string;
      stepIcons: [string, string, string];
    };
  }
}

export const sgOnBoarding: SgApplicationConfiguration<'sg-onboarding'> = {
  name: 'sg-onboarding',
  authType: 'noAuth',
  branding: {
    css: ['sg-default-theme', 'sg-onboarding-theme'],
    preLogo: 'assets/images/sharegain-logo-horizontal-black-on-white.svg',
    hideSideNav: true,
    hideTopBar: true,
    backgroundImg: 'assets/sg-onboarding/images/main-page.svg',
    favIcon: 'assets/images/favicon/favicon.ico',
    custom: {
      logoMainPage: 'assets/images/sharegain-logo-horizontal-black-on-white.svg',
      stepIcons: [
        'assets/sg-onboarding/images/search-icon.svg',
        'assets/sg-onboarding/images/contract-icon.svg',
        'assets/sg-onboarding/images/earnings-icon.svg',
      ],
    },
  },
  brandingMap: {
    citi: {
      css: 'sg-citi-onboarding-theme',
      logo: 'assets/sg-onboarding/images/sharegain-logo-citi-light.svg',
      preLogo: 'assets/images/sharegain-logo-citi.svg',
      favIcon: 'assets/images/favicon/citi-favicon.ico',
      backgroundImg: 'assets/sg-onboarding/images/citi-background.jpg',
      custom: {
        logoMainPage: 'assets/sg-onboarding/images/sharegain-logo-citi-light.svg',
        stepIcons: [
          'assets/sg-onboarding/images/citi-bank-contrast-logo.svg',
          'assets/sg-onboarding/images/citi-bank-contrast-logo.svg',
          'assets/sg-onboarding/images/citi-bank-contrast-logo.svg',
        ],
      },
    },
  },
  matcher: (location: Location) => {
    return (
      ONBOARDING_APP_DETECT_REGEXP.test(location.pathname) ||
      ONBOARDING_APP_DETECT_REGEXP.test(location.hash) ||
      HOSTNAME_DETECT_REGEXP.test(location.hostname)
    );
  },
};
